module.exports = __webpack_public_path__ + "static/media/Coders-Crux.0685cd17.svg";